import VideoExhaustedModalComponent from "./VideoExhaustedModalComponent";

export default VideoExhaustedModalComponent;